import { jsx, jsxs } from "react/jsx-runtime";
function PreviewEmpty() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M52.5 12H15C13.3431 12 12 13.3431 12 15V52.5C12 54.1569 13.3431 55.5 15 55.5H52.5C54.1569 55.5 55.5 54.1569 55.5 52.5V15C55.5 13.3431 54.1569 12 52.5 12Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M105 12H67.5C65.8431 12 64.5 13.3431 64.5 15V52.5C64.5 54.1569 65.8431 55.5 67.5 55.5H105C106.657 55.5 108 54.1569 108 52.5V15C108 13.3431 106.657 12 105 12Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M105 64.5H67.5C65.8431 64.5 64.5 65.8431 64.5 67.5V105C64.5 106.657 65.8431 108 67.5 108H105C106.657 108 108 106.657 108 105V67.5C108 65.8431 106.657 64.5 105 64.5Z",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M99.7312 100.916C100.39 101.575 101.459 101.575 102.118 100.916C102.777 100.257 102.777 99.1886 102.118 98.5296L99.7312 100.916ZM92.5211 93.7059L99.7312 100.916L102.118 98.5296L94.9076 91.3195L92.5211 93.7059Z",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "85.3025",
                cy: "84.1008",
                r: "11.531",
                stroke: "#AFB9C9",
                strokeWidth: "3.375"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M52.5 64.5H15C13.3431 64.5 12 65.8431 12 67.5V105C12 106.657 13.3431 108 15 108H52.5C54.1569 108 55.5 106.657 55.5 105V67.5C55.5 65.8431 54.1569 64.5 52.5 64.5Z",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("rect", {
                x: "26.25",
                y: "24.75",
                width: "21",
                height: "3.75",
                rx: "1.875",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "24.75",
                cy: "26.25",
                r: "4.5",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("rect", {
                width: "21",
                height: "3.75",
                rx: "1.875",
                transform: "matrix(-1 0 0 1 41.25 37.5)",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "4.5",
                cy: "4.5",
                r: "4.5",
                transform: "matrix(-1 0 0 1 47.25 35.25)",
                fill: "#EBEFF5"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M76.8911 45.5837L76.8911 35.4011",
                stroke: "#EBEFF5",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M85.8911 45.5837L85.8911 29.5824",
                stroke: "#EBEFF5",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M94.8911 45.5837L94.8911 25.2184",
                stroke: "white",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M24.75 96.8652L24.75 86.6825",
                stroke: "#EBEFF5",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M33.75 96.8652L33.75 80.8639",
                stroke: "#EBEFF5",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M42.75 96.8652L42.75 76.4999",
                stroke: "#EBEFF5",
                strokeWidth: "3.75",
                strokeLinecap: "round"
            })
        ]
    });
}
export { PreviewEmpty as default };
